<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Motorista</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('motorista.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('motorista.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('motorista.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'pessoa_motorista'">
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/motorista"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="pesmot_id"
                    pagination-path=""
                    detail-row-component="motorista-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="tp_vinculo" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.tp_vinculo.valor == 'F'"
                        >{{ props.rowData.tp_vinculo.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.tp_vinculo.valor == 'A'"
                        >{{ props.rowData.tp_vinculo.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.tp_vinculo.valor == 'T'"
                        >{{ props.rowData.tp_vinculo.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          v-if="getPermissionFw('motorista.update')"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <a
                          @click="sendDoc(props.rowData.pesmot_id)"
                          v-b-tooltip
                          title="Enviar Documento"
                          ><i class="fa fa-id-card-o"></i
                        ></a>
                        <span v-if="getPermissionFw('motorista.status')">
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 1)"
                            v-b-tooltip
                            title="Cadastrar gerenciamento risco"
                            ><i class="fa fa-external-link"></i
                          ></a>
                          <a
                              @click="onEventoGerRisco(props.rowData, 6)"
                              v-b-tooltip
                              title="Enviar foto gerenciamento risco"
                          ><i class="fa fa-picture-o"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 5)"
                            v-b-tooltip
                            title="Enviar foto pessoal gerenciamento risco"
                            v-if="getPermissionFw('motorista.fotopessoalgerrisco')"
                            ><i class="fa fa-picture-o"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 2)"
                            v-b-tooltip
                            title="Consultar gerenciamento risco"
                            ><i class="fa fa-compass"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 3)"
                            v-b-tooltip
                            title="Pesquisa gerenciamento risco"
                            ><i class="fa fa-search"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 4)"
                            v-b-tooltip
                            title="Pesquisa expressa gerenciamento risco"
                            ><i class="fa fa-bolt"></i
                          ></a>
                          <a
                            @click="onIntegration(props.rowData.pessoa_id)"
                            v-b-tooltip
                            title="Integrar Gestão de pagamento"
                            ><i class="fa fa-credit-card"></i
                          ></a>
                          <a
                            @click="onDetail(props.rowData, null, null)"
                            v-b-tooltip
                            title="Ver detalhes"
                            ><i class="fa fa-plus"></i
                          ></a>
                        </span>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SendDocForm ref="senddocform" :rota="'motorista'" />
      <MotoristaForm
        ref="motoristaform"
        :metodo="onFilterReset"
        :tabela="'pessoa_motorista'"
        :rota="'motorista'"
      >
      </MotoristaForm>
    </div>
  </div>
</template>

<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import MotoristaFilterBar from "./MotoristaFilterBar";
import MotoristaForm from "./MotoristaForm";
import moment from "moment";
import MotoristaDetalhes from "./MotoristaDetalhes";
import SendDocForm from "./SendDocForm.vue";

Vue.component("motorista-detalhes", MotoristaDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    MotoristaForm,
    SendDocForm,
    "vuetable-filterbar": MotoristaFilterBar,
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      optionsPessoaFisica: [],
      optionsCategoria: [],
      optionsTpSituacao: [],
      optionsTpVinculo: [],
      optionsLivStatus: [],
      helpForm: new Form({
        statusRecord: [],
        status: "",
        pessoa_id: "",
        pesmot_id: "",
        tipo_evento: "",
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "pessoa_fisica.nome",
          title: "Nome",
        },
        {
          name: "pessoa_fisica.cpf",
          title: "CPF",
        },
        {
          name: "cnh",
          title: "CNH",
        },
        {
          name: "dt_vencimento_cnh",
          title: "Data de vencimento CNH",
          callback: "formatDate|DD/MM/YYYY",
        },
        {
          name: "categoria.descr",
          title: "Categoria",
        },
        {
          name: "__slot:tp_vinculo",
          title: "Tipo vínculo",
        },
        {
          name: "__slot:status",
          title: "Status",
        },

        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.pesmot_id);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        nome: data_filter.nome,
        cpf: data_filter.cpf,
        cnh: data_filter.cnh,
        dt_expiracao_ini: data_filter.dt_expiracao_ini,
        dt_expiracao_fim: data_filter.dt_expiracao_fim,
        categoria: data_filter.categoria.value,
        tp_vinculo: data_filter.tp_vinculo.value,
        tp_situacao: data_filter.tp_situacao.value,
        status: data_filter.status.value,
      };
      if(data_filter.tp_situacao.value == 0){
        this.moreParams.tp_situacao = 99;
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.motoristaform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.parban_id;
      this.$refs.motoristaform.onEdit(data, index, this.id);
    },
    sendDoc(data) {
      this.$refs.senddocform.onCreate(data);
    },
    onIntegration(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.pessoa_id = id;
      this.helpForm
        .post("/api/motorista/gestaopagamento")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/motorista/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.pessoa_fisica.forEach((obj) => {
            this.optionsPessoaFisica.push({
              label: obj.nome + " - " + obj.cpf,
              value: obj.pessoa_id,
            });
          });
          response.status.forEach((obj) => {
            this.optionsLivStatus.push({
              text: obj.descr,
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_vinculo.forEach((obj) => {
            this.optionsTpVinculo.push({
              text: obj.descr, 
              label: obj.descr, 
              value: obj.valor,
            });
          });
          response.tp_situacao.forEach((obj) => {
            this.optionsTpSituacao.push({
              text: obj.descr, 
              label: obj.descr, 
              value: obj.valor,
            });
          });
          response.categoria.forEach((obj) => {
            this.optionsCategoria.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({id: data.pesmot_id, status:action});
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }
      this.$refs.motoristaform.onActivateDesactivate(this.helpForm);
    },
    onEventoGerRisco(data, tipo_evento) {
      this.helpForm.pesmot_id = data.pesmot_id;
      this.helpForm.tipo_evento = tipo_evento;
      this.helpForm
        .post("/api/motorista/gerenciamentorisco")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
